import { useCurrentSpaceContext, usePunditUserContext } from "@/react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";

export const useCanDownloadAttendeeList = () => {
  const { currentCommunityMember, currentCommunitySettings } =
    usePunditUserContext();
  const { data: space } = useCurrentSpaceContext();
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const canManageSpace = !!space?.policies?.can_manage_space;
  const isCommunitySettingAllowModeratorCsvDownload =
    currentCommunitySettings?.allow_moderator_csv_download;

  return (
    isAdmin || (canManageSpace && isCommunitySettingAllowModeratorCsvDownload)
  );
};
